<script>
export default {
  props: {
    texto: {
      type: String,
      required: true
    }
  },
  mounted () {
    const iframe = this.$refs.iframe

    iframe.contentDocument.open()
    iframe.contentDocument.write(this.texto)
    iframe.contentDocument.close()

    if (iframe.contentWindow.document.body) {
      iframe.style.height = iframe.contentWindow.document.body.scrollHeight + 'px'
    }
  }
}
</script>

<template>
  <div class="main-container">
    <div class="card-container">
      <iframe
        ref="iframe"
        class="iframe-content"
        frameborder="0"
        scrolling="no"
      ></iframe>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/App/(authenticated)/termos/components/termo-container/termo-container.vue